<template>
  <div>
    <template v-if="hasProducts">
      <div class="container-fluid">
        <template>
          <div class="row row-list-product align-items-center">
            <div class="table-responsive">
              <table class="table table-hover customTable">
                <tr>
                  <th style="width:25%">Produto</th>
                  <th style="width:8%" class="text-center">Unidade</th>
                  <th style="width:8%" class="text-center">CFOP</th>
                  <th style="width:8%" class="text-center">CEST</th>
                  <th style="width:8%" class="text-center">NCM</th>
                  <th style="width:8%" class="text-center">CSOSN</th>
                  <th style="width:8%" class="text-center">Quantidade</th>
                  <th style="width:8%" class="text-center">Preço</th>
                  <th style="width:8%" class="text-center">Total</th>
                  <th style="width:0%"></th>
                </tr>
                <tbody>
                  <tr v-for="(row, index) in products" :key="index">
                    <td style="width:25%">{{ row.product }}</td>
                    <td style="width:8%" class="text-center">{{ row.unit}}</td>
                    <td style="width:8%" class="text-center">{{ row.cfop}}</td>
                    <td style="width:8%" class="text-center">{{ row.cest}}</td>
                    <td style="width:8%" class="text-center">{{ row.ncm}}</td>
                    <td style="width:8%" class="text-center">{{ row.csosn}}</td>
                    <td style="width:8%" class="text-center">{{ row.quantity | decimal }}</td>
                    <td style="width:8%" class="text-center">{{ row.price | decimal }}</td>
                    <td style="width:8%" class="text-center">{{ row.quantity * row.price | decimal}}</td>
                    <td style="width:0%" class="text-center">
                      <button class="btn btn btn-light" @click="$emit('editProduct', index)">
                        <i class="text-info fas fa-pen" />
                      </button>
                      <button
                        style="margin-left:10px"
                        class="btn btn btn-light"
                        @click="$emit('deleteProduct', index)"
                      >
                        <i class="text-info fas fa-trash" />
                      </button>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </template>
      </div>
    </template>
    <template v-else>
      <span class="text-info">Utilize o formulario acima para adicionar produtos...</span>
      <br />
    </template>
  </div>
</template>

<script>
export default {
  props: {
    value: {},
    products: {}
  },

  methods: {
    hasProducts() {
          console.log(this.products);
      return this.products.length > 0;
    }
  }
};
</script>
